import React, { useState } from 'react';
import { Collapse, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import { AccountDropdown } from './AccountDropdown';
import './NavMenu.css';

interface NavMenuProps {
  onToggleSidebar?: () => void;
}

export const NavMenu: React.FC<NavMenuProps> = ({ onToggleSidebar }) => {
  const [collapsed, setCollapsed] = useState<boolean>(true);
  const [themeDropdownOpen, setThemeDropdownOpen] = useState<boolean>(false);
  const { isAuthenticated } = useAuth();
  const { theme, setTheme, actualTheme } = useTheme();
  
  const toggleNavbar = () => {
    setCollapsed(!collapsed);
  };

  const toggleThemeDropdown = () => {
    setThemeDropdownOpen(!themeDropdownOpen);
  };

  const getThemeIcon = () => {
    if (theme === 'auto') {
      return actualTheme === 'dark' ? '🌙' : '☀️';
    }
    return theme === 'dark' ? '🌙' : '☀️';
  };

  return (
    <header>
      <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" container="fluid" light>
        <div className="d-flex align-items-center">
          {isAuthenticated && onToggleSidebar && (
            <button
              className="btn btn-outline-secondary btn-sm me-2"
              onClick={onToggleSidebar}
              title="Toggle sidebar"
            >
              ☰
            </button>
          )}
          <NavbarBrand tag={Link} to="/">CollabSafe AI</NavbarBrand>
        </div>
        <NavbarToggler onClick={toggleNavbar} className="mr-2" />
        <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!collapsed} navbar>
          <ul className="navbar-nav flex-grow">
            <NavItem>
              <NavLink tag={Link} className="text-body" to="/">Home</NavLink>
            </NavItem>
            
            <NavItem className="d-flex align-items-center">
              <ButtonDropdown 
                isOpen={themeDropdownOpen} 
                toggle={toggleThemeDropdown}
                size="sm"
              >
                <DropdownToggle 
                  caret 
                  color="outline-secondary"
                  className="me-2"
                  style={{ border: 'none', background: 'transparent' }}
                >
                  {getThemeIcon()}
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem 
                    onClick={() => setTheme('light')}
                    active={theme === 'light'}
                  >
                    ☀️ Light
                  </DropdownItem>
                  <DropdownItem 
                    onClick={() => setTheme('dark')}
                    active={theme === 'dark'}
                  >
                    🌙 Dark
                  </DropdownItem>
                  <DropdownItem 
                    onClick={() => setTheme('auto')}
                    active={theme === 'auto'}
                  >
                    🔄 Auto
                  </DropdownItem>
                </DropdownMenu>
              </ButtonDropdown>
            </NavItem>
            
            {isAuthenticated ? (
              <NavItem className="d-flex align-items-center">
                <AccountDropdown />
              </NavItem>
            ) : (
              <NavItem>
                <NavLink tag={Link} className="text-body" to="/login">Login</NavLink>
              </NavItem>
            )}
          </ul>
        </Collapse>
      </Navbar>
    </header>
  );
};